module.exports = require("esprima");